import * as Account     from '../account';
import * as Campaigns   from '../campaigns';
import * as Contacts    from '../contacts_page';
import * as Inbox       from '../inbox';
import * as Integration from '../integration';
import * as Metrics     from '../metrics';
import * as Onboarding  from '../onboarding';
import * as Settings    from '../settings';
import * as TeamChat    from '../team_chat';
import * as User        from '../user';
import { onDeepLink }   from './deep_links';
import { Panel }        from 'framework7-react';
import { View }         from 'framework7-react';
import { Views }        from 'framework7-react';
import bail             from '../util/bail';
import F7Event          from './events/f7_event';
import logEvent         from './events/amplitude_log_event';
import NotFoundPage     from '../components/not_found_page';
import React            from 'react';
import SplitView        from '../components/split_view';
import store            from '../store';
import Tab              from '../components/tab';

// LEGACY - Reroutes to /inbox and /contacts
import * as Customers   from '../customers';


// This is the main view.  All applications have one.
//
// All routing happens on the main view, to so navigate:
//   app.views.main.router.navigate(url)
const mainViewParams = {
  // TODO don't need this when running in Cordova.
  pushState:           true,
  // TODO An empty push separator should work, except for a couple of bugs in
  // the code.  Need to submit PR and fix those.
  pushStateSeparator:  '#',
  pushStateRoot:       getPushStateRoot(),
  animate:             true,
  animateWithJS:       false,
  stackPages:          false,
  preloadPreviousPage: false,
  reloadCurrent:       true,
  on:                  {
    routeChange,
    pageInit: initializeDeepLinksOnApplicationStart
  },
  routesBeforeEnter(to, from, resolve, reject) { // eslint-disable-line max-params
    // this flag is being set in the Link component
    const { isOpeningExternalLink } = window;
    const isCallbackRoute           = to?.path.includes('oauth2callback');

    if (isOpeningExternalLink || isCallbackRoute)
      reject();
    else
      resolve();
  },
  routes: [{
    path:     '/',
    redirect: (route, resolve) => {
      const locationIDs = User.getLocationIDs(store.getState());
      const businessID  = locationIDs && locationIDs[0];

      if (businessID) {
        const url = `/${businessID}/inbox`;
        resolve(url);
      } else
        bail();
    }
  },
  Onboarding.routes,
  Integration.routes,
  Customers.routes,
  Metrics.routes,
  Settings.routes,
  TeamChat.routes,
  Account.routes,
  Campaigns.routes,
  Contacts.routes,
  Inbox.routes,
  {
    path:      '(.*)',
    component: NotFoundPage
  }]
};

export default function MainView() {
  return (
    <SplitView>
      <Panel left cover opened>
        <Tab/>
      </Panel>
      <Views tabs>
        <View id="main" className="view-main" main init {...mainViewParams}/>
      </Views>
    </SplitView>
  );
}

// In Cordova, the pathname is the location of the app on the file system.
// It must be excluded from the current URL, otherwise many things break.
// In the browser, the pathname is /.  There's a bug in F7, where during
// initial page load, it uses split instead of replace, and so would discard
// all of the document fragment identifier.  It works if we return null.
function getPushStateRoot() {
  const { pathname } = document.location;
  return (pathname === '/') ? null : pathname;
}


let routerReady;
let deepLinkOnApplicationStart;

// Must register deep link handler early on.
onDeepLink(function(url) {
  const { pathname } = url;

  if (!pathname)
    return;

  // Special handling pre-authentication, see app/index.js.
  if (pathname.includes('/signin/passwordless'))
    return;

  if (routerReady) {
    setTimeout(() => {
      handleDeepLink(url);
    }, 300);
  } else
    deepLinkOnApplicationStart = url;
});


function initializeDeepLinksOnApplicationStart() {
  // If the app is starting as a result of a deep link,
  // delay navigation until router ready.
  //
  // If we navigate too early, Back button breaks.
  //
  // Did not find a way to determine when router becomes
  // ready after initial page load, so using a two-second delay.
  if (deepLinkOnApplicationStart && !routerReady) {
    const pendingDeepLink      = deepLinkOnApplicationStart;
    deepLinkOnApplicationStart = null;
    setTimeout(() => {
      handleDeepLink(pendingDeepLink);
    }, 2000);
  }

  routerReady = true;
}


function handleDeepLink({ pathname }) {
  document.body.dispatchEvent(new F7Event(app => {
    const { router } = app.views.main;
    if (router)
      router.navigate(pathname, { animate: false });
  }));
}


function routeChange(currentRoute) {
  logPageViewEvent(currentRoute);
}


function logPageViewEvent(route) {
  if (route.name) {
    const eventName  = `View${route.name}`;
    const { params } = route;
    logEvent(eventName, params);
  }
}
